import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

import {
  Card,
  Grid,
  TextField,
  InputLabel,
  MenuItem,
  Select,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDSnackbar from "components/MDSnackbar";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { Navigate } from "react-router-dom";

export default class AddBlogs extends Component {
  state = {
    allCategories: [],
    blog_category: "",
    blogs_title: "",
    blogs_poster: null,
    blog_tags: "",
    blog_content: "",

    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
    loading: false,
  };

  componentDidMount() {
    this.getAllBlogCategories();
  }

  /* =========================
     FETCH CATEGORIES
  ========================= */
  getAllBlogCategories = () => {
    if (init() !== "success") return window.location.assign("/signin");

    axios
      .get(`${Constants.getUrls.getAllBlogCategories}?limit=100`)
      .then((resp) => {
        if (resp.data.status === "success") {
          this.setState({ allCategories: resp.data.data });
        }
      })
      .catch(() => {
        this.showSnackbar("error", "Error fetching categories");
      });
  };

  /* =========================
     HELPERS
  ========================= */
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  showSnackbar = (color, message) => {
    this.setState({ notification: true, notiColor: color, message });
    setTimeout(() => {
      this.setState({ notification: false, message: "" });
    }, 3000);
  };

  /* =========================
     SUBMIT
  ========================= */
  handleSubmit = async (e) => {
    e.preventDefault();
    if (init() !== "success") return;

    this.setState({ loading: true });

    const fd = new FormData();
    fd.append("blog_category", this.state.blog_category);
    fd.append("blogs_title", this.state.blogs_title);
    fd.append("blog_tags", this.state.blog_tags);
    fd.append("blog_content", this.state.blog_content);

    if (this.state.blogs_poster) {
      fd.append("blogs_poster", this.state.blogs_poster);
    }

    try {
      const resp = await axios.post(Constants.postUrls.createBlogs, fd);

      this.showSnackbar("success", resp.data.message || "Blog created");
      setTimeout(() => this.setState({ redirect: true }), 2000);
    } catch (err) {
      this.showSnackbar(
        "error",
        err?.response?.data?.message || "Something went wrong"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  /* =========================
     RENDER
  ========================= */
  render() {
    if (this.state.redirect) return <Navigate to="/blogs" replace />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>
            <MDBox
              mx={2}
              mt={-3}
              py={3}
              px={2}
              variant="gradient"
              bgColor="info"
              borderRadius="lg"
              coloredShadow="info"
            >
              <MDTypography variant="h6" color="white">
                Add Blog
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  {/* BLOG TITLE */}
                  <Grid item sm={6}>
                    <TextField
                      fullWidth
                      required
                      label="Blog Title"
                      name="blogs_title"
                      value={this.state.blogs_title}
                      onChange={this.handleChange}
                    />
                  </Grid>

                  {/* BLOG POSTER */}
                  <Grid item sm={6}>
                    <TextField
                      type="file"
                      label="Blog Poster"
                      InputLabelProps={{ shrink: true }}
                      onChange={(e) =>
                        this.setState({ blogs_poster: e.target.files[0] })
                      }
                    />
                  </Grid>

                  {/* BLOG TAGS */}
                  <Grid item sm={6}>
                    <TextField
                      fullWidth
                      label="Blog Tags"
                      name="blog_tags"
                      value={this.state.blog_tags}
                      onChange={this.handleChange}
                      style={{marginTop: "20px"}}
                    />
                  </Grid>

                  {/* BLOG CATEGORY */}
                  <Grid item sm={6}>
                    <InputLabel sx={{ mb: 1 }}>
                      Blog Category
                    </InputLabel>

                    <Select
                      fullWidth
                      required
                      name="blog_category"
                      value={this.state.blog_category}
                      onChange={this.handleChange}
                      displayEmpty
                      sx={{ height: "45px" }}
                    >
                      <MenuItem value="">Select Blog Category</MenuItem>
                      {this.state.allCategories.map((item) => (
                        <MenuItem key={item._id} value={item._id}>
                          {item.category}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  {/* BLOG CONTENT */}
                  <Grid item sm={12}>
                    <MDTypography mb={1}>
                      Blog Content
                    </MDTypography>

                    <SunEditor
                      setContents={this.state.blog_content}
                      onChange={(content) =>
                        this.setState({ blog_content: content })
                      }
                      setOptions={{
                        height: 200,
                        buttonList: [
                          ["undo", "redo"],
                          ["font", "fontSize"],
                          ["bold", "underline", "italic"],
                          ["fontColor", "hiliteColor"],
                          ["align", "list"],
                          ["link"],
                          ["removeFormat"],
                        ],
                      }}
                    />
                  </Grid>

                </Grid>

                <Grid mt={3}>
                  <MDButton
                    type="submit"
                    color="info"
                    disabled={this.state.loading}
                  >
                    {this.state.loading ? "Creating..." : "Create Blog"}
                  </MDButton>
                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              icon="notifications"
              title="Blogs Admin"
              content={this.state.message}
              dateTime="Just now"
              open={this.state.notification}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}
